export enum STORY_VISIBILITY {
  private = 'private',
  hidden = 'hidden',
  public = 'public',
}
